import { ConnectionSection } from './ConnectionSection';
import { FormattedMessage } from 'react-intl';
import { Box, Button, Typography } from '@mui/material';
import { OutgoingConnectionItem } from './OutgoingConnectionItem';
import { OutgoingConnections } from '../hook/useUserConnection';
import { useConnectionDispatch } from './ConnectionDispatchProvider';
import { useFetchMoreOutgoingConnections } from '../hook/useFetchUserConnection';
import { LoadingIndicator } from '@xolv-mybrightlink/common';

type OutgoingConnectionProps = {
  outgoingConnections: OutgoingConnections;
};

export const OutgoingConnectionSection = ({
  outgoingConnections,
}: OutgoingConnectionProps) => {
  const { connections, hasMore } = outgoingConnections;
  const connectionDispatch = useConnectionDispatch();
  const loadMore = useFetchMoreOutgoingConnections(
    outgoingConnections,
    connectionDispatch,
  );
  const title = (
    <Typography variant='subtitle1'>
      <FormattedMessage
        id='community.connections.connection-pending.title'
        values={{ numOfConnection: connections.length }}
      />
    </Typography>
  );
  const detail = (
    <Box>
      {connections.map((connection) => (
        <OutgoingConnectionItem key={connection.guid} connection={connection} />
      ))}
      {hasMore && outgoingConnections.loading && <LoadingIndicator />}
      {hasMore && !outgoingConnections.loading && (
        <Button onClick={loadMore} variant='text' sx={{ px: 0 }}>
          Load more
        </Button>
      )}
    </Box>
  );
  return <ConnectionSection title={title} detail={detail} />;
};
